// @flow
import {
	FETCH_PODS,
	FETCH_PODS_SUCCESS,
	FETCH_PODS_ERROR,
	INITIATE_FETCH_PODS,
	SELECT_POD,
	RESET_SELECT_POD,
	FETCH_POD_BANNERS,
	FETCH_POD_BANNERS_SUCCESS,
	FETCH_AFFILIATE,
	FETCH_AFFILIATE_SUCCESS,
	FETCH_AFFILIATE_ERROR,
	SET_AFFILIATE_DATA,
} from './types';
import type { Action } from './types';

export const fetchPods = (mobile: string): Action => ({
	type: FETCH_PODS,
	payload: {
		mobile,
	},
});

export const initiateFetchPods = (): Action => ({
	type: INITIATE_FETCH_PODS,
});

export const fetchPodsSuccess = (podList: Array<any>): Action => ({
	type: FETCH_PODS_SUCCESS,
	payload: podList,
});

export const fetchPodsError = (error: any): Action => ({
	type: FETCH_PODS_ERROR,
	payload: error,
});

export const selectPod = (pod: any): Action => ({
	type: SELECT_POD,
	payload: pod,
});

export const resetSelectedPod = (): Action => ({
	type: RESET_SELECT_POD,
});

export const fetchPodBanners = (imei: string): Action => ({
	type: FETCH_POD_BANNERS,
	payload: imei,
});

export const fetchPodBannerSuccess = (bannerList: Array<string>): Action => ({
	type: FETCH_POD_BANNERS_SUCCESS,
	payload: bannerList,
});

export const fetchAffilate = (url: string, navigated: boolean, mobile: string): Action => ({
	type: FETCH_AFFILIATE,
	payload: {
		url,
		navigated,
		mobile,
	},
});

export const fetchAffilateSuccess = (pod: any, affiliateData: {[key: string]: any}): Action => ({
	type: FETCH_AFFILIATE_SUCCESS,
	payload: {pod, affiliateData},
});

export const fetchAffilateError = (error: any): Action => ({
	type: FETCH_AFFILIATE_ERROR,
	payload: error,
});

export const setAffilateData = (active: boolean, data?: {[key: string]: any}): Action => ({
	type: SET_AFFILIATE_DATA,
	payload: { active, data},
});
